//en.js
const en = {
	navbar: {
		cxq:'Labs',
		st:'Stay tuned',
		home:'Home',
		pool: 'Pool',
		blockinfo: 'Blocks',
		paymenthistory: 'Payment',
		calc: 'Calculate',
		autominer: 'Auto Config',
		mineraddress: 'Miner Address',
		error: 'error',
		ica: 'Invalid Monero Address',
		inhint: 'Enter Monroe Address',
		inhinttitle: 'Info',
		iem: 'Invalid Monero Address',
		confirm: 'OK',
		cancel: 'Cancel',
		quertButton: 'Check',
		chat:"ChatRoom",
		login:"Login"
	},
	footer: {
		product: 'Product',
		product_item1: 'C3Pool',
		product_item2: 'Calculate',
		help: 'Help',
		help_item1: 'How to use xmrig-proxy',
		help_item2: '如何指定算法',
		help_item3: '使用xmrig-proxy',
		help_item4: '更多使用教程',
		about: 'About',
		about_item1: 'About Us',
		about_item2: 'Privacy Policy',
		about_item3: 'Terms of Service',
		about_item4: 'Disclaimer',
		qgroup: '官方QQ群：',
		qgroup_item1: '一群：',
		qgroup_item2: '二群：',
		qgroup_item3: '三群：',
		qgroup_item4: '四群：',
		qgroup_item5: '五群：',
		full: '(满)',
		links: 'Links：'
	},
	index: {
		pool_title: 'Star Map, A Different Mining Pool',
		pool_desc: 'One-Stop Service, Making Mining Easy',
		netdiff: 'Network Hashrate',
		algo: 'Algo',
		coinstatus: 'Notes',
		fee: 'Fee Rate',
		paymenttime: 'Payout Time',
		payThreshold: 'Payout Threshold',
		payfre: '2 hours',
		cnaddress: 'General Mining URL',
		foreignaddress: 'Global Node',
		tlsaddrss: 'Encrypted Mining URL',
		coinname: 'Coin',
		syl: 'Profit',
		syl_desc: 'Profit per hash in percent',
		price: 'Coin Price',
		award: 'Reward',
		effort: 'Effort',
		poolHash: 'Pool Hashrate',
		netHash: 'Network Hashrate',
		minercount: 'Active Miners',
		help: 'Help',
		chartspriceunit: 'USD',
		chartshashunit: 'Network Hashrate',
		chartstitle: 'Network Hashrate&Price',
		coinstat: 'Active',
		coinstat2: 'Deviant',
		coinstatus: 'Active',
		copysuccess: 'Copy',
		copysuccess_msg: 'Please paste it into the config file to use',
		tiptitle: 'Info',
		helpdoc: 'Help',
		paymenttime2:"12:00-16:00",
		payType:"ETH",
		payfre2: '12:00-16:00',
		support:"Withdrawal",
		netdiff:"Network Difficulty",
		cpu:"CPU Profits switch",
		gpu:"GPU Labs"
	},
	block: {
		title: 'Blocks',
		selectcoin: 'Coins:',
		table_id: '#',
		table_ts: 'Found Time',
		table_effort: 'Effort',
		table_rawaward: 'Block Reward',
		table_payment: 'Payment (XMR)',
		table_blockheight: 'Block Height',
		mins: 'Min',
		soon: 'Soon...',
		delay: 'Delayed...',
		nullify: 'Orphaned',
		secago: ' Sec Ago',
		minago: ' Min Ago',
		hourago: ' Hrs Ago',
		dayago: ' Days Ago',
		monago: ' Month Ago',
	},
	calc: {
		title: "Monero (XMR) Mining Calculator",
		kw: 'Kwh',
		df: 'Cost',
		yjcb: 'Hardware cost',
		kccs: 'Pool Fee',
		dqbj: 'Price',
		kjsl: 'Hashrate',
		input_kw: 'Enter Kwh',
		input_df: 'Enter $/Kwh',
		input_cb: 'Enter Hardware cost',
		input_csbl: 'Enter Pool Fee',
		input_dqbj: 'Price',
		input_sl: 'Enter Hashrate',
		buttontitle: 'Calculate',
		wfhb: 'No Profit',
		hbsj: 'Payback Time',
		nethash: 'Network Hashrate',
		nethiff: 'Difficulty',
		gjbj: 'Shutdown price',
		mrjsy: 'Profit(24h)',
		mzjsy: 'Profit(Week)',
		myjsy: 'Profit(Month)',
		mnjsy: 'Profit(Year)',
		mrcz: 'Revenue/Day',
		mryd: 'Cost(KWh)',
		mrdf: 'Electricity Consumption/Day',
		mzcz: 'Revenue/Week',
		mzyd: 'Cost(KWh)',
		mzdf: 'Electricity Consumption/Week',
		mycz: 'Revenue/Month',
		myyd: 'Cost(KWh)',
		mydf: 'Electricity Consumption/Month',
		mncz: 'Revenue/Year',
		mnyd: 'Cost(KWh)',
		mndf: 'Electricity Consumption/Year',
		r: 'Day',
		z: 'Week',
		y: 'Month',
		n: 'Year',
	},
	autominer: {
		title: 'Xmrig Configuration wizard',
		title_desc: 'Please select the appropriate system version below to configure your miner.',
		win: 'Windows',
		linux: 'Linux',
		mac: 'Mac',
		wallet_address: 'Monero Address',
		minername: 'Worker Name',
		wallet_input: 'Please enter the Monero wallet address',
		minername_input: 'Please enter Worker Name',
		ljsc: 'Download',
		dqsb: 'Device Information',
		dqllq: 'Browser',
		dqxt: 'Operating System',
		jianyi: 'Recommended Version',
		input_add: 'Please enter Monero wallet Address',
		input_cadd: 'Please enter correct Monroe Address',
		err: 'Error',
		errmsg: 'Address Error',
		errmsg2: 'Unknown Error, Configuration Failed',
		warn: 'Warning',
		warnmsg: 'Unable To Generate',
		panel_win: 'windows Version',
		panel_linux: 'Linux Version',
		panel_mac: 'MacOs Version',
		panel_mobile: 'It is currently a mobile device and cannot be used',
		panel_ubknown: 'Unknown Version',
		
	},
	anonminer: {
		online:'Online',
		offline:'Offline',
		offline_table:'No Data',
		wallet_address: 'Monero Address:',
		input_tip: 'Enter Monero Address',
		input_over: 'Check',
		panel_title_1: 'Dashboard',
		panel_title_2: 'Workers',
		panel_title_3: 'Payments',
		panel_title_4: 'Your Block Payments',
		panel_title_5: 'Setup',
		title_hash: 'Hashrate',
		title_miner: 'Workers',
		title_earnings: 'Earnings',
		realhahs: 'Real Time',
		realhahs_desc: 'PAY Hashrate',
		avghash24: '24H Avg',
		avghash24_desc: 'Avg Hashrate',
		avghash4: '4H Avg',
		avghash4_desc: 'Avg Hashrate',
		due: 'XMR Total Due',
		paid: 'XMR Paid',
		chartstip: 'Help',
		mineremputtip: 'No miners',
		id: '#',
		minername: 'Name',
		lts: 'Last Hash',
		payhash: 'Pay Hashrate',
		rawhash: 'Raw Hashrate',
		validshares: 'Valid Shares',
		invalidshares: 'Invalid Shares',
		totalhash: 'Total Hashes',
		input_search_miner: 'Search',
		clickmore: 'See More',
		paymentdate: 'Payment Date',
		paymentvalue: 'Payment Amount(XMR)',
		blockpaymentdate: 'Block Pay Time',
		blockfounddate: 'Block Found Time',
		blockpercent: 'Block share (percent)',
		blockname: 'Coin name',
		clickcopy: 'Copy Block Hash',
		prepage: 'Last',
		nextpage: 'Next',
		paychartstitle: 'PAY History Hashrate',
		rawchartstitle: 'RAW History Hashrate',
		paychartsunit: 'PAY Hashrate',
		rawchartsunit: 'RAW Hashrate',
		linkwalleterr: 'Monero Address Wrong',
		copysuccess: 'Copy',
		copyerror: 'Browser Not Support Copying',
		yqtx: 'Info：',
		tomoreminer: 'Please wait!',
		warntip: 'Warning',
		warntip_desc: 'Please enter Monroe address',
		success: 'Success',
		updatesuccess: 'Threshold updated',
		unknownerror: 'Unknown Error',
		unknownerror_desc: 'Update Failed',
		updatewarn: 'Update every 24 hours',
		updatewarn_desc: 'Time left：',
		echartsquestiontip: 'The chart data is the data per minute in the last few days, if the fluctuation is large, it is normal',
		echartsquestiontiptitle: 'Chart explanation',
		msgtokf: 'Reminder: If you have any other questions, please contact us',
		valid: 'Valid:',
		invalid: ',Invalid:',
		lts2: 'Last Hash：',
		secago: ' Sec Ago',
		minago: ' Min Ago',
		hourago: ' Hrs Ago',
		dayago: ' Days Ago',
		monago: ' Month Ago',
		onesecago: '1 Sec',
		wallet_emptytip: 'Please enter Monroe address',
		minercount: 'Miners',
		totalshares: 'Total Hashes',
		activeminer: 'Active Miners',
		minerunit: 'Worker',
		gxxe: 'Update Threshold',
		reset: 'Reset',
		setaddress: 'Address management',
		addressempty: 'Unknown Address',
		cz: 'Operating',
		del: 'Delete',
		yjjb: 'Miner Setup Scripts',
		winjb: 'Windows Scripts',
		linuxjb: 'Linux Scripts',
		copyjb: 'Copy',
		sec: ' seconds',
		mins: ' minutes and ',
		hour: ' hours,',
		zdxe: 'The minimum limit is 0.003XMR',
		confirmbutton: 'OK',
		shell_install:'Install',
		shell_uninstall:'Uninstall',
		txfee:"tx fee：+0.0001XMR"
	},
	paymenthistory: {
		title: 'Payments',
		pay_ts: 'Payment Time',
		pay_payees: 'Payees',
		pay_value: 'Amount (XMR)',
		pay_fee: 'Fee (XMR)',
	},
	navbar2: {
			login: "Sign In",
			logout: "Sign Out",
			usercenter: "User Center",
			loginfail: "Email or password is incorrect",
		},
		sidebar: {
			selectcoin: "Coin select",
			usersetting: "User Setting",
			course: "Help",
			discord1: "Labs Forum",
			discord2: "Star Map English",
			course2:"Withdrawal help",
			invite:"Invite",
			inmail:"InMail",
			yubibao:"Coin Interest",
			jinrong:"Finance",
			baoxian:"Insurance",
			wange:"Grid trading",
			jiedai:"Borrowing",
			bilicai:"Structured",
			wallet:"Wallet"
		},
		labseth: {
			myaccount: "Sub-account Manage",
			addaccount: "Create a Sub-account",
			accountName: "Sub-account Name",
			remark: "Add memo",
			confirm: "Create",
			cancel: "Cancel",
			changeaccount: "Switch sub-account",
			accountid: "UID of sub-account",
			accountName2: "Sub-account Name",
			option: "operate",
			select: "select",
			realearn:"Real-time income",
	        tixian:"Withdraw",
	        all:"All",
	        codeerr1:"Code Error",
	        addfail:"Withdrawal Failed",
			tobesubbalance: "Balance",
			nowsubbalance: "Transfer",
			online: "Active",
			realtimehash: "Hashrate",
			empty: "No machine",
			stale: "Stale",
			minedisc: "Rewards rules",
			earnmodel: "payout scheme",
			fee: "Fee",
			intoaccount: "Payout time",
			intoaccountdisc: "Withdraw cash on the same day and arrive the next day",
			support: "Support",
			bindgoogle: "Bind Google Authenticator",
			googledisc: "Google Authenticator is a dynamic password tool. The working principle is similar to that of SMS dynamic verification. After binding, the dynamic key changes every 30 seconds. It can be used for login, withdrawal, modification of security settings and other security verifications.",
			step1: "Step 1: Download the Google Authenticator APP",
			step1disc: "iOS users log in to the App Store and search for 'Authenticator' to download, and Android users log in to the app store or use the mobile browser to search for 'Google Authenticator' to download.",
			step2: "Step 2: add the key in Google Authenticator and back it up",
			step2disc: "Open Google Authenticator, scan the QR code below or manually enter the key below to add a verification token.",
			googeldisc2: "The key is used to modify the password or the account is lost to retrieve the Google Authenticator. Please be sure to save the key backup and prevent leakage before binding!",
			step3: "Step 3: Verify the 6-digit verification code in Google Authenticator",
			googelcode: "Google verification code",
			googlecodetip: "Please enter verification code",
			googelcodeconfirm: "verification",
			addpaymentaccount: "Add payout account",
			paymentaccounttip: "You have not been bound to Google verification, you will not be able to withdraw cash",
			clickmetobind: "Click me to bind",
			biantip: "Only supports Binance Smart Chain (BEP20/BSC) network",
			usdttip: "Only supports Tron (TRC20) network",
			alipaytip: "Please remember the key, it is related to your withdrawal(Use letters + numbers to define the key)",
			addtype: "Add type",
			selectaddtype: "Please select add type",
			key8: "8-bit key",
			accountaddress: "Account address",
			alias:"memo",
			accountalias:"Account memo",
			nowadd:"ADD",
			paymentoption:"Payouts",
			addpaymentorderaccount:"Add withdrawal account",
			paymenttipwithgoogle:"You have not been bound to Google verification, you will not be able to withdraw cash",
			usdtsdisc1:"USDT only supports payment using the TRX network [Tron(TRC20)]",
			usdtsdisc2:"Minimum: 20 USDT",
			ethdisc1:"ETH only supports BSC network [Binance Smart Chain (BEP20)] for payment.",
			ethdisc2:"The paid amount will be paid after deducting the network fee",
			ethdisc3:"Minimum: 0.01 ETH",
			ethdisc4:"Minimum: 0.5 ETC",
			selectkey:"Select key,If you do not bind the email, the withdrawal will not be sent",
			alipaydisc:"Minimum: 100 CNY",
			paymenttype:"Withdraw type",
			selectpaymenttype:"Please select the withdrawal type",
			usdtpayment:"USDT Network Fee: 1 USDT",
			ethpayment:"ETH(BSC) Network Fee: 0.000070 ETH",
			alipaypayment:"Alipay Fee:1%",
			ketishuliang:"Available quantity",
			payaccount:"Withdrawal account",
			selectpayaccount:"Please select a withdrawal account",
			paycount:"Aamount",
			tixiantip:"Before 0:00 on the same day, it will be processed from 12:00 noon-16:00 pm on the next day",
			nowpay:"Withdraw",
			paymenthistory:"Withdrawal History",
			date:"Date",
			id:"ID",
			type:"Type",
			unknown:"Unknown",
			money:"Aamount",
			search:"Search",
			wcl:"Untreated",
			clz:"Waiting",
			yzf:"Paid",
			yth:"Returned",
			err:"Error",
			nodeaddress:" Pool Address：",
			nodetip:"Please do not use the Chinese name, otherwise you will not be able to mine!",
			t_rex:"T-rex Configuration：",
			minername:"Mining account",
			minname:"Worker",
			phoexminer:"PhoenxMiner Configuration：",
			nbminer:"Nbminer Configuration:",
			gminer:"Gminer Configuration:",
			teamredminer:"Teamredminer Configuration:",
			input:"Please enter the 6-digit verification code",
			codeerr:"Code format error",
			inputeth:"Please enter ETH wallet address",
			addresserr:"Wallet address wrong",
			balanceinsuf:"Insufficient balance",
			googelcodetitle:"Please open the Google verification app on your mobile phone and enter the 6-digit verification code displayed on your mobile phone",
			googelcodetip:"Enter the code",
			confirmbtn:"Confirm",
			cancel:"Cancel",
			coderegerr:"Incorrect format",
			optinerr:"Illegal operation！",
			codeerr:"Code error!",
			unknown:"Unknown!",
			addsuccess:"Added successfully",
			addexist:"sub-account already exists",
			loginfail:"Login status is invalid, re-login",
			addtip:"sub-account name starts with 'st_'",
			bindsuccess:"Successful.",
			copysuccess:"Copy successfully.",
			copytip:"Please keep it!",
			unbindgoogel:"Google verification has not been bound, please bind first!",
			banaccount:"Account is blocked, please initiate a ticket processing",
			cnypaytip:"Minimum 100 CNY",
			usdtpaytip:"Minimum 20 USDT",
			ethpaytip:"Minimum 0.01 ETH",
			addpaysuccess:"Withdraw successfully",
			addpayfail:"Failed to create order",
			addpayonceday:"Only one withdrawal per day",
			addpaybalanceinsuff:"Insufficient balance",
			unbindemaill:"Unbound email, Alipay withdrawal is prohibited！",
			down:"Download",
			minersetting:"Mining settings",
			alipaykeyerr:"Alipay key format is wrong, only supports numbers and letters",
			accountmanager:"Manager Account",
			addresserr:"Address Error",
			unknownerr:"Unknown Error",
			openlist:"Open page",
			closelist:"Close page",
			deletesuccess:"Remove Success",
			deleteerror:"Remove Unsuccessful",
			accounttype:"Type",
			accountaddress:"Address",
			accountname:"Name",
			accountoption:"Operation",
			accountremove:"Remove",
			hashcharts:"12 Hours Hashrate",
			lastdayearn:"Earnings Yesterday",
			todayearn:"Today's Earnings",
			lastdayearndisc:"AM 00:00:00 - PM 23:59:59 (Join on the first day, there will be a partial delay of 30 Min)",
			todayearndisc:"Day 00:00:00 - Now",
			sfsyobserver:"Whether to enable observer",
			observertip:"After opening, check miner information without login",
			copyobserver:"Copy",
			openobserver:"Open",
			miner:"Miners",
			earning:"Reward",
			
			hashrate:"Hashrate",
			totalshare:"Total Shares",
			Valid:"Valid",
			Stale:"Stale",
			Invalid:"Invalid",
			miners:"Miners",
			localhash:"Local Hashrate",
			standby:"Standby",
			temporarymaintenance:"Temporary Maintenance ",
			okextip:"Only supports OKExChain(OKC) network",
			okexpayment:"ETH(OKC) No Fee",
			okexdisc1:"ETH only supports OKC network [OKEx Chain] for payment.",
			bankcard:"银行卡提现 手续费:2%",
			realname:"RealName",
			noresubmit:"Do not submit twice",
			unknown1:"Unknown",
			jine:"Amount:",
			wallet_address2:"Wallet:",
			tixiantype:"Type:",
			tixiandilogtip:"Please confirm the wallet carefully. It cannot be changed after submission!",
			eachEarn:"每M收益",
			thresholdTip:"预更改阈值：",
			thresholdTip2:"提现阈值最小为0.05",
			walletTip:"预修改提现地址为：",
			walletTip2:"需Ethereum Classic钱包地址，请确认钱包是否正确,因绑定错钱包而造成损失需自己承担后果。",
			walletTip3:"Only support ETC mainet, please confirm whether the wallet is correct to avoid unnecessary losses.",
			gohash:"Check",
			address:"Wallet",
			txhash:"Tx Hash",
		closure:"Suspension of withdrawals, resumption time pending notice"
		},
		
		observer:{
			wktobserver:"The subaccount is not open to observers"
		},
	noticelist:{
		check:"Check",
		personalnotice:"Personal Notice",
		systemnotice:"System Notice"
		
	},
	bata:{
		wallet:"",
		yubibao:"",
		baoxian:"",
		wange:"",
		jiedai:"",
		bilicai:"",
		tip:" It is only open to qualified users"
	}
}
export default en;
